import { Link } from "react-router-dom";

const stats = [
  { num: "3+", label: "常设栏目" },
  { num: "天天", label: "持续更新" },
  { num: "首发", label: "一手追踪" },
];

export default function AboutBand() {
  return (
    <section className="border-t border-background-300/60 bg-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-8 px-4 py-12 md:grid-cols-2 md:px-6 md:py-14">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-news-line" /> 关于每日爆料网
          </span>
          <h2 className="mt-4 font-serif text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            把娱乐圈与网红圈的资讯，
            <br className="hidden md:block" />
            做得更快一点、更真一点。
          </h2>
          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-foreground-700">
            我们是一群常年泡在热搜与后台之间的内容人。比起追逐浮在表面的热度，我们更在意热度之下的事实与分寸。每日爆料网坚持客观记录、理性表达，让每一篇报道都对得起读者的时间。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            查看我们的故事 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-3 gap-4">
          {stats.map((s, i) => (
            <div key={s.label} className={`rounded-xl p-5 text-center ${i === 1 ? "bg-accent-400 text-secondary-900" : "bg-secondary-100 text-secondary-900"}`}>
              <p className="font-serif text-2xl font-black md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}